module.exports = __webpack_public_path__ + "img/product_service19.fb45de70.png";